import { FunctionComponent } from 'react'
import { SeparatorProps } from './Separator.types'
import './Separator.scss'

export const Separator: FunctionComponent<SeparatorProps> = ({
  attributes,
  children
}) => {
  return (
    <div
      className="core-ux-separator"
      data-testid="separator"
      style={{ height: attributes.height, backgroundColor: attributes.color }}>
      {children}
    </div>
  )
}
